import React from 'react';
import { MapPin } from 'lucide-react';
import { coverageAreas } from '../data/mock';

const CoverageSection = () => {
  return (
    <section id="coverage" className="py-24 bg-[#ECEC75]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            We Travel Anywhere in the GTA
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            No matter where you are in the Greater Toronto Area, our mobile technicians will come to you.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl">
          <div className="flex items-center justify-center gap-3 mb-8">
            <MapPin className="w-8 h-8 text-black" />
            <span className="text-2xl font-bold text-gray-900">Service Areas</span>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {coverageAreas.map((area, index) => (
              <div 
                key={index}
                className="bg-gray-100 hover:bg-[#e6e67c] px-4 py-3 rounded-lg text-center font-medium text-gray-900 transition-colors cursor-default"
              >
                {area}
              </div>
            ))}
          </div>

          <p className="text-center text-gray-600 mt-8">
            Don't see your area? <span className="font-semibold text-gray-900">Call us anyway!</span> We likely cover it.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CoverageSection;
